module.exports = __webpack_public_path__ + "img/1536979342.0b21cf3f.jpg";